/* Importing Stylesheet */
import styles from "./style.module.scss";

const Loader = () => {
  return (
    <div className={styles.loader}>
      <span className={styles.bar}></span>
      <span className={styles.bar}></span>
      <span className={styles.bar}></span>
    </div>
  );
};

export default Loader;
